import { ThemeColorType, SET_PRIMARY_COLOR } from "./actionsTypes";

export const setPrimaryColor = (color: string): ThemeColorType => { 
  const myWindow : any = window;
  myWindow.less.modifyVars({
    '@primary-color': color
  });
  return ({ type: SET_PRIMARY_COLOR, payload: color });
};
